import React from 'react';
import { reportItemClassName } from 'src/utils/constants';
import { keyboardClickable } from 'src/utils/a11y-utils';

interface ExecutiveSummaryReportItemProps {
    isSelected: boolean;
    onClick: () => void;
}

const ExecutiveSummaryReportItem: React.FC<ExecutiveSummaryReportItemProps> = ({ isSelected, onClick }) => {
    return (
        <div
            className={`executive-summary-item ${reportItemClassName + (isSelected ? ' selected' : '')}`}
            style={{ cursor: 'pointer' }}
            {...keyboardClickable(onClick)}
            data-testid="executive-summary-item">
            <div className="header-report-item">Executive Summary</div>
        </div>
    );
};

export default ExecutiveSummaryReportItem;


